import shape from "../../assets/img/shapes/left-shape-01.webp";


const LeftShape01 = () => {

    return (
        <div className="rmdr-left-shape-01">
            <img src={shape} alt="rmdr-left-shape-01" loading="lazy" width={119} height={216} />
        </div>
    )

}

export default LeftShape01;
